module.exports = __webpack_public_path__ + "static/media/dotnet.cb04569b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/dotnet.png
// module id = 92
// module chunks = 0